import { PATHS } from '../config';
import { dynoapeAPI } from '../dynoape';
import type { ShiftType, ShiftTypeRequest } from './Models';

const getShiftTypes = async (departmentId: string): Promise<ShiftType[]> =>
    await dynoapeAPI.get(PATHS.shiftTypes(departmentId));

const createShiftType = async (
    departmentId: string,
    shiftType: ShiftTypeRequest,
): Promise<ShiftType> =>
    await dynoapeAPI.post(PATHS.shiftTypeCreate(departmentId), shiftType);

const updateShiftType = async (
    departmentId: string,
    shiftTypeId: string,
    shiftType: ShiftTypeRequest,
): Promise<ShiftType> =>
    await dynoapeAPI.put(PATHS.shiftType(departmentId, shiftTypeId), shiftType);

const deleteShiftType = async (
    departmentId: string,
    shiftTypeId: string,
): Promise<true> =>
    (await dynoapeAPI.delete(PATHS.shiftType(departmentId, shiftTypeId))) ??
    true;

const ShiftTypeService = {
    getShiftTypes,
    createShiftType,
    updateShiftType,
    deleteShiftType,
};

export default ShiftTypeService;
